import { IShader, ShaderBase } from '../shader';
import { Scene, Material, PBRMetallicRoughnessMaterial } from '@babylonjs/core';

export class ShaderTasma extends ShaderBase implements IShader {

    public diffuse: string = '';
    public normal: string = '';
    public avatar: string = '';
    public text: string = '';

    public get key(): string { return 'ShaderTasma'; }

    public getMaterial(scene: Scene, light: string): Material {
        const tape = new PBRMetallicRoughnessMaterial('glass', scene);
        tape.metallic = 0.3;
        // const hdrTexture = store.getters.scene.hdrTexture.clone();
        // hdrTexture.gammaSpace = true;
        // tape.reflectionTexture = hdrTexture;
        // tape.indexOfRefraction = 0.52;
        tape.alpha = 0.5;
        // tape.directIntensity = 0.0;
        // tape.environmentIntensity = 0.7;
        // // tape.cameraExposure = 0.66; // to powoduje problem
        // tape.cameraContrast = 1.66;
        // tape.microSurface = 1;
        // tape.reflectivityColor = new Color3(0.2, 0.2, 0.2);
        // tape.albedoColor = new Color3(0.95, 0.95, 0.95);
        tape.backFaceCulling = false;
        return tape;
    }

    addLight(scene: Scene, material: Material, light: string): Material {
        return material;
    }
}
